import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./header.css";
import Popupboxx from "../Popupbox/Popupbox";
import { useNavigate } from "react-router-dom";


function Headers() {
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate(); // 🔥 Redirect

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please verify the CAPTCHA");
      return;
    }

    setIsLoading(true); // Start button loading

    const formData = new FormData(e.target);
    formData.append("g-recaptcha-response", captchaValue);

    fetch("https://fazoacademy.in/php/sendmail.php", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((msg) => {
        console.log(msg);

        // Reset form
        e.target.reset();
        setCaptchaValue(null);

        // Go to Thankyou Page
        navigate("/thankyou");

        // Close popup if open
        setIsPopupOpen(false);
      })
      .catch(() => alert("Something went wrong!"))
      .finally(() => {
        setIsLoading(false); // Stop button loading
      });
  };

  return (
    <>
      <section className="header-wrapper">
        <div className="hero-section">
          <div className="caption-left">
            <h1>Advance Your Career with Expert-Led Software Testing</h1>
            <p>
              Become job-ready through real-time learning, personalized mentoring, and hands-on practice.
            </p>
            {/* <p>
              Our 3-month program is designed to help you secure a high-paying testing role with strong
              technical and interview skills.
            </p>
            <p>Start your professional journey with the right foundation.</p> */}
            <div className="form-wrapper">
              <form className="enquiry-form" onSubmit={handleSubmit}>
                <center> <h4>Your IT Career Starts Here!</h4></center>
                <div className="row-group">
                  <input type="text" name="name" placeholder="Your Name" required />
                  <input type="tel" name="phone" placeholder="Phone Number" required />
                </div>


                <div className="row-group">
                  <input type="email" name="email" placeholder="Email Address" required />
                  <input type="message" name="message" placeholder="Message" required />
                </div>


                <input type="hidden" name="subject" value="Course Enquiry for Testing" />

                <div className="row-group">
                  <ReCAPTCHA
                    sitekey="6LcvphEsAAAAAEDI2D1bp3KMfYffeD_THqRX6-gG"
                    onChange={(value) => setCaptchaValue(value)}
                  />


                  <button type="submit" className="submit-btn" disabled={isLoading}>
                    {isLoading ? "Sending..." : "Request Callback"}
                  </button>
                </div>
              </form>
            </div>

            {/* <div className="header-buttons">
              <button className="call-btn" onClick={() => setIsPopupOpen(true)}>
                Call Now
              </button>
              <button className="enquiry-btn" onClick={() => setIsPopupOpen(true)}>
                Enquiry
              </button>
            </div> */}
          </div>

          <div className="caption-right  d-none">
            <form className="inline-form" onSubmit={handleSubmit}>
              {/* <h4>Your IT Career Starts Here!</h4> */}

              <input type="text" name="name" placeholder="Your name" required />
              <input type="tel" name="phone" placeholder="Phone number" required />
              <input type="email" name="email" placeholder="Email address" required />
              <input type="hidden" name="subject" value="Course Enquiry for Testing" />

              <textarea name="message" placeholder="Message" required rows="3"></textarea>

              <ReCAPTCHA
                sitekey="6LcvphEsAAAAAEDI2D1bp3KMfYffeD_THqRX6-gG"
                onChange={(value) => setCaptchaValue(value)}
              />

              <button type="submit" className="cta-btn" disabled={isLoading}>
                {isLoading ? "Sending..." : "Request Callback"}
              </button>
            </form>
          </div>
        </div>
      </section>


      <Popupboxx isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}

export default Headers;
